import productsActionTypes from "./productsActionTypes";

const initialState = {
  pending: false,
  productsList: [],
  productGroupPending: false,
  productCategoryPending: false,
  productsGroups: [],
  productGroupsIndented: [],
  brands: [],
  suppliers: [],
  supplierTypes: [],
  productsCategory: [],
  productCategoryIndented: [],
  assortments: [],
  vatRates: [],
  companyTypes: [],
  currencies: [],
  priorityGroups: [],
  productCountries: [],
  error: null,
  totalCount: "",
  productGroupTotal: "",
};

const productsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case productsActionTypes.GET_ALL_PRODUCTS_START:
    case productsActionTypes.GET_BRANDS_START:
    case productsActionTypes.GET_SUPPLIERS_START:
    case productsActionTypes.GET_VAT_RATES_START:
      return {
        ...state,
        pending: true,
      };

    case productsActionTypes.GET_PRODUCT_CATEGORY_START:
      return {
        ...state,
        productCategoryPending: true,
      };

    case productsActionTypes.GET_PRODUCT_GROUPS_START:
      return {
        ...state,
        productGroupPending: true,
      };

    case productsActionTypes.GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        pending: false,
        productsList: payload,
      };

    case productsActionTypes.GET_PRODUCT_TOTAL_COUNT_SUCCESS:
      return {
        ...state,
        totalCount: payload,
      };

    case productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_SUCCESS:
      return {
        ...state,
        productGroupTotal: payload,
      };

    case productsActionTypes.GET_PRODUCT_GROUPS_SUCCESS:
      return {
        ...state,
        productsGroups: payload.sort((a, b) => a.order - b.order),
        productGroupPending: false,
      };

    case productsActionTypes.GET_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        productCategoryPending: false,
        productsCategory: payload.sort((a, b) => a.order - b.order),
      };

    case productsActionTypes.GET_PRIORITY_GROUP_SUCCESS:
      return {
        ...state,
        priorityGroups: payload.sort((a, b) => a.order - b.order),
      };

    case productsActionTypes.GET_PRODUCT_COUNTRY_SUCCESS:
      return {
        ...state,
        productCountries: payload,
      };

    case productsActionTypes.GET_BRANDS_SUCCESS:
      return {
        ...state,
        pending: false,
        brands: payload,
      };

    case productsActionTypes.GET_ASSORTMENTS_SUCCESS:
      return {
        ...state,
        assortments: payload,
      };

    case productsActionTypes.GET_SUPPLIERS_SUCCESS:
      return {
        ...state,
        pending: false,
        suppliers: payload,
      };

    case productsActionTypes.GET_VAT_RATES_SUCCESS:
      return {
        ...state,
        pending: false,
        vatRates: payload,
      };

    case productsActionTypes.GET_COMPANY_TYPES_SUCCESS:
      return {
        ...state,
        companyTypes: payload,
      };

    case productsActionTypes.GET_COMPANY_TYPES_FAILED:
      return {
        ...state,
        companyTypes: [],
      };

    case productsActionTypes.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: payload,
      };

    case productsActionTypes.GET_CURRENCIES_FAILED:
      return {
        ...state,
        currencies: [],
      };

    case productsActionTypes.GET_SUPPLIER_TYPES_SUCCESS:
      return {
        ...state,
        supplierTypes: payload,
      };

    case productsActionTypes.GET_SUPPLIER_TYPES_FAILED:
      return {
        ...state,
        supplierTypes: [],
      };

    case productsActionTypes.GET_ALL_PRODUCTS_FAILED:
      return {
        ...state,
        pending: false,
        productsList: [],
      };

    case productsActionTypes.GET_INDENTED_CATEGORY_SUCCESS:
      return {
        ...state,
        productCategoryIndented: payload,
      };

    case productsActionTypes.GET_INDENTED_CATEGORY_FAILED:
      return {
        ...state,
        productCategoryIndented: [],
      };

    case productsActionTypes.GET_INDENTED_GROUPS_SUCCESS:
      return {
        ...state,
        productGroupsIndented: payload,
      };

    case productsActionTypes.GET_INDENTED_GROUPS_FAILED:
      return {
        ...state,
        productGroupsIndented: [],
      };

    case productsActionTypes.GET_BRANDS_FAILED:
    case productsActionTypes.GET_SUPPLIERS_FAILED:
    case productsActionTypes.GET_ASSORTMENTS_FAILED:
    case productsActionTypes.GET_PRODUCT_TOTAL_COUNT_FAILED:
    case productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_FAILED:
    case productsActionTypes.GET_VAT_RATES_FAILED:
      return {
        ...state,
        pending: false,
        error: payload,
      };

    case productsActionTypes.GET_PRODUCT_CATEGORY_FAILED:
      return {
        ...state,
        productCategoryPending: false,
      };

    case productsActionTypes.GET_PRODUCT_GROUPS_FAILED:
      return {
        ...state,
        productGroupPending: false,
      };

    case productsActionTypes.GET_PRIORITY_GROUP_FAILED:
      return {
        ...state,
        priorityGroups: payload,
      };

    case productsActionTypes.GET_PRODUCT_COUNTRY_FAILED:
      return {
        ...state,
        productCountries: payload,
      };

    default:
      return state;
  }
};

export default productsReducer;
